/* eslint-disable no-prototype-builtins */
import moment from 'moment';
import compact from 'lodash/compact';
import Cookies from 'js-cookie';

// 轉換target是否開新頁
// 因為後端可能沒傳值(undefined)，但希望預設不要開新視窗
export const targetLinkSwitch = (target) => (target === 'Y' ? '_blank' : '_self');

// 所有 OwlCarousel 左右箭頭 image
export const owlCarouselArrowImage = [
  "<img src='/_ui/responsive/theme-trplus/app/images/mobile/index/m-arrow-left-grey-default.svg'>",
  "<img src='/_ui/responsive/theme-trplus/app/images/mobile/index/m-arrow-right-grey-drfault.svg'>",
];

// number / currency convert function
export const numberToCurrency = (number) => {
  const n = Number(number);
  if (Number.isNaN(n) || number === '') {
    return '';
  }
  return `$${n.toFixed(0).replace(/./g, (c, i, a) => {
    const currency = i && c !== '.' && (a.length - i) % 3 === 0 ? `, ${c}`.replace(/\s/g, '') : c;
    return currency;
  })}`;
};
export const currencyToNumber = (currency) => Number(currency.replace(/[^0-9.-]+/g, ''));

// address / zipcode convert

// 首頁用通路名稱換成品牌色轉換器
export const mobileIndexBrandColorTranslator = (brandText) => {
  switch (brandText) {
    case '特力屋':
      return '--tlw';
    case 'HOLA':
      return '--hola';
    case 'hoi!':
      return '--hoi';
    case 'CB':
      return '--cnb';
    default:
      return brandText;
  }
};

// 判斷廣告欄位時間區間是否過期
export const isExpiryDate = (time) => {
  const now = Date.now();
  const expiryDate = moment(time).format('x');
  return now < expiryDate;
};

// 分類資料轉換器
export const categoryFormatter = (categoryData) => {
  /*
    CN = cateName
    CC = cateID
    IL = isLastNode
    LV = Level
    SM = shownNavigationMenu
  */

  if (categoryData === {} || !categoryData) {
    return categoryData;
  }

  const formatterData = {
    storeID: categoryData.ST,
    categoryID: categoryData.CC,
    categoryName: categoryData.CN,
    categoryPic: categoryData.CP,
    isLastNode: categoryData.IL,
    level: categoryData.LV,
    shownNavigationMenu: categoryData.SM,
    nextLevelCategory: categoryData.subNodes,
    linkUrl: categoryData.LK,
  };

  return formatterData;
};

// 手機選單 Api request資料轉換 （apiGetMobileMenuData）
export const apiGetMobileMenuDataRequest = (categoryItem) => {
  // 通路
  // storeID: "TRPlus",
  // cateID: "tlwCategory",
  // isNew: true

  // 分類
  // storeID: TRPlus
  // cateID: EC_10114000
  // isNew: true
  const formatterData = {
    cateID: categoryItem.hasOwnProperty('CC') ? categoryItem.CC : categoryItem.cateID,
    storeID: categoryItem.hasOwnProperty('storeID') ? categoryItem.storeID : categoryItem.ST,
    isNew: true,
  };

  if (formatterData.storeID === undefined) {
    formatterData.storeID = 'TRPlus';
  }
  if (formatterData.cateID === undefined) {
    formatterData.cateID = categoryItem.categoryID;
  }

  return formatterData;
};

// 宇匯推薦 (你可能會喜歡) - 首頁、通路首頁
export const getYouMayAlsoLike = (updateTrplusOtherAlsoLikeProduct, channel) => {
  const params = setYouMayAlsoLikeParams(channel);
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: params.pid,
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 'trplusOtherAlsoLikeProducts',
        cate: params.layoutCate,
        // 回傳商品數量
        count: 20,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateTrplusOtherAlsoLikeProduct(returnproducts);
      },
    },
  });
};

// 設定「你可能會喜歡」宇匯參數
export const setYouMayAlsoLikeParams = (channel) => {
  const params = {
    pid: 'home',
    layoutCate: 'EC_100000000',
  };

  switch (channel) {
    case 'TRPLUS':
      params.pid = 'home';
      params.layoutCate = 'EC_100000000';
      break;
    case 'TLW':
      params.pid = 'tlw';
      params.layoutCate = 'EC_200000000';
      break;
    case 'HOLA':
      params.pid = 'hola';
      params.layoutCate = 'EC_300000000';
      break;
    case 'HOI':
      params.pid = 'hoi';
      params.layoutCate = 'EC_500000000';
      break;
    case 'CB':
      params.pid = 'cb';
      params.layoutCate = 'EC_700000000';
      break;
    case 'TRHOME':
      params.pid = 'trhome';
      params.layoutCate = 'EC_600000000';
      break;
    default:
      params.pid = 'home';
      params.layoutCate = 'EC_100000000';
      break;
  }

  return params;
};

// 宇匯推薦 (你可能會喜歡) 旗艦高階
export const getBrandYouMayAlsoLike = (updateTrplusOtherAlsoLikeProduct) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: 'brand',
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 0,
        // 回傳商品數量
        count: 20,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateTrplusOtherAlsoLikeProduct(returnproducts);
      },
    },
  });
};

// 宇匯推薦 (其他人也買了) 旗艦一般
export const getBrandYouMayAlsoBuy = (updateOtherAlsoBuyProduct) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: 'brand',
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 1,
        // 回傳商品數量
        count: 20,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateOtherAlsoBuyProduct(returnproducts);
      },
    },
  });
};

// 宇匯推薦（別人也買了）商品頁
export const getProductPageOtherAlsoLike = (updateTrplusOtherAlsoLikeProduct, sku, cateId) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: 'item',
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 'alsoview',
        viewitem: sku,
        cate: cateId,
        // 回傳商品數量
        count: 15,
        // "layoutid": "alsoview",
        // "viewitem": "1122",
        // "cate":"3650",
        // "count":10
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateTrplusOtherAlsoLikeProduct(returnproducts);
      },
    },
  });
};

// 宇匯推薦（你可能會喜歡）搜尋頁
export const getSearchPageYouMayAlsoLike = (updateTrplusOtherAlsoLikeProduct) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: 'search',
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 0,
        // 回傳商品數量
        count: 15,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateTrplusOtherAlsoLikeProduct(returnproducts);
      },
    },
  });
};

// 宇匯推薦 (其他人也買了) 搜尋頁
export const getSearchPageOtherAlsoBuy = (updateOtherAlsoBuyProduct) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: 'footer',
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 0,
        // 回傳商品數量
        count: 15,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateOtherAlsoBuyProduct(returnproducts);
      },
    },
  });
};

// 取得分類你可能會喜歡
export const getCategoryOtherAlsoLike = (updateOtherAlsoLikeProduct, params) => {
  // 宇匯推薦 trigger 的地方
  const scupioInitialData = {
    // 傳過去的方法參數
    scupioConnectMethod: '_bwec_rec',
    // 廣告主 id
    mid: '22',
    // 網頁類型和裝置，需要針對桌機、手機跟App，需要後面加上"不處理/_m/_app"加工
    pid: params.cateIDIndex,
    layouts: [
      {
        // 各頁面識別碼
        layoutid: 0,
        // 分類代碼
        cate: params.cateIDNumber,
        // 回傳商品數量
        count: 15,
      },
    ],
  };

  // 處理 pid
  if (window.isMobile) {
    scupioInitialData.pid += '_m';
  }

  (window[scupioInitialData.scupioConnectMethod] = window[scupioInitialData.scupioConnectMethod] || []).push({
    mid: scupioInitialData.mid,
    pid: scupioInitialData.pid,
    rec: {
      layouts: scupioInitialData.layouts,
      success(products) {
        // 這邊負責修改網頁 render 推薦
        const [returnproducts] = products;
        updateOtherAlsoLikeProduct(returnproducts);
      },
    },
  });
};

// 設定 popUp 廣告 cookies
export const setPopupAdvCookies = () => {
  const timSec = 24 * 60 * 60
    - (new Date().getHours() * 60 * 60 + new Date().getMinutes() * 60 + new Date().getSeconds());
  const exp = new Date();
  exp.setTime(exp.getTime() + timSec * 1000);

  document.cookie = `hasOpenSpecial=1;path=/;expires=${exp};`;
};

// 設定 smartBanner 廣告 cookies
export const setSmartBannerCookies = () => {
  let exp = new Date();
  exp.setTime(exp.getTime() + 864e5);
  exp = `expires=${exp.toGMTString()}`;
  document.cookie = `m_s_bn=1; ${exp}; path=/;`;
};

/**
 * 判斷是否是四通路
 * @returns {Boolean} 如果是的話回傳true，反之false
 */
export const isChannelHomePage = () => {
  const currentUrl = window.location.pathname.toLowerCase();
  const channelPageUrl = ['/tlw', '/hoi', '/hola', '/crateandbarrel'];
  return channelPageUrl.some((url) => currentUrl.search(url) !== -1);
};

// 取得、更新搜尋紀錄（由新到舊排序）
export const getSearchHistoryCookies = () => {
  // let fakecookies = "桌子,椅子,櫃子,";
  const isExist = document.cookie.indexOf('searchHistory=');
  if (isExist !== -1) {
    const getSearchHistoryCookie = Cookies.get('searchHistory');
    const searchLists = encodeURI(getSearchHistoryCookie, 'utf-8');
    const searchListsDecode = decodeURI(searchLists, 'utf-8');
    let searchListsArray = searchListsDecode.split(',');
    searchListsArray = compact(searchListsArray);
    document.cookie = `searchHistory=${searchLists};path=/`;

    return searchListsArray;
  }
  document.cookie = 'searchHistory=;path=/';

  return false;
};

// 刪除單一搜尋紀錄
export const deleteSearchHistory = (index) => {
  const getSearchHistoryCookie = Cookies.get('searchHistory');
  let searchLists = encodeURI(getSearchHistoryCookie, 'utf-8');
  const searchListsDecode = decodeURI(searchLists, 'utf-8');
  let searchListsArray = searchListsDecode.split(',');
  searchListsArray = compact(searchListsArray);
  delete searchListsArray[index];
  searchListsArray = compact(searchListsArray);
  searchLists = searchListsArray.join(',');
  document.cookie = `searchHistory=${searchLists};path=/`;

  return searchListsArray;
};

// 按下搜尋按鈕存搜尋紀錄cookies
export const setSearchHistoryCookies = (searchWord) => {
  const getSearchHistoryCookie = encodeURI(Cookies.get('searchHistory'), 'utf-8');
  const searchWordForStorageCookies = encodeURI(searchWord, 'utf-8');
  let cookies = [];
  const getSearchHistoryCookieArr = getSearchHistoryCookie.split(',');
  cookies = getSearchHistoryCookieArr;
  const isUnique = getSearchHistoryCookieArr.findIndex((e) => e === searchWordForStorageCookies);
  if (isUnique === -1) {
    cookies = [searchWordForStorageCookies, ...cookies];
  }

  document.cookie = `searchHistory=${cookies};path=/`;
};

// 為了排 commonFooter 的 key 的排序, 因為後端吐過來的順序是亂的
export const sortObj = (obj) => Object.keys(obj)
  .sort()
  .reduce((result, key) => {
    result[key] = obj[key];

    return result;
  }, {});

// 曾經發生過的問題清單
// 這邊要記得後面可能要把從後端給出來的圖片連結全部整理成 cdn / s3 上面的
// 篩選 wording 是/否 轉換
export const translatePhrase = (phrase) => {
  switch (phrase) {
    case 'true':
      return '是';
    case 'false':
      return '否';
    default:
      return phrase;
  }
};

// 商品頁取得麵包屑最後一層 Id 要去打宇匯「別人也買了」
export const getBreadcrumbLastNodeId = (categoryTree) => {
  const categoryTreeLength = categoryTree.length;
  return categoryTree[categoryTreeLength - 1];
};

// 商品頁轉換 productType 標籤
export const switchProductTypeTags = (text) => {
  if (!text) {
    return;
  }
  switch (text) {
    case '預購':
      return '/_ui/responsive/theme-trplus/app/images/mobile/icon/pc-ic-pre-order.svg';
    case '訂製':
      return '/_ui/responsive/theme-trplus/app/images/mobile/icon/pc-ic-custom.svg';
    case '火速配':
      return '/_ui/responsive/theme-trplus/app/images/mobile/icon/pc-ic-fast.svg';
    default:
      return text;
  }
};

// 商品頁取得貨況 - 預設內湖區、取得經緯度打API
export const getNowLocation = () => {
  const location = {
    latitude: '25.0689422',
    longitude: '121.59090270000002',
  };
  navigator.geolocation.getCurrentPosition((position) => {
    location.latitude = position.coords.latitude;
    location.longitude = position.coords.longitude;
  });

  return location;
};

// 手機版 trplus 選單 「品牌旗艦館」通路 className 轉換
export const translateMenuSideBarClassName = (menuSideBarDataClassName) => {
  switch (menuSideBarDataClassName) {
    case 'tlwCategory':
      return 'TLW';
    case 'holaCategory':
      return 'Hola';
    case 'hoiCategory':
      return 'hoi';
    case 'cbCategory':
      return 'cb';
    case 'trbrandCategory':
      return 'trhome';
    default:
      return '';
  }
};

// 桌機版 trplus 側選單「品牌旗艦」通路連結轉換
export const transFormCategoryNameToLink = (menuSideBarDataClassName) => {
  switch (menuSideBarDataClassName) {
    case 'tlwCategory':
      return '/TLW';
    case 'holaCategory':
      return '/Hola';
    case 'hoiCategory':
      return '/hoi';
    case 'cbCategory':
      return '/crateandbarrel';
    case 'trbrandCategory':
      return '/trhome';
    default:
      return '/brand/c/EC_10146000';
  }
};

/**
 * 判斷是否是通路頁
 * 如果是的話顯示桌機、手機特力家選單品牌旗艦的通路元件
 * @returns {Boolean} 如果是的話回傳true，反之false
 */
export const isShowBrandComponent = (channelCC) => {
  const channelCCOptions = [
    'tlwCategory',
    'holaCategory',
    'hoiCategory',
    'cbCategory',
    'trbrandCategory',
  ];
  return channelCCOptions.some((channelCCOption) => channelCC === channelCCOption);
};

// 判斷信用卡類別回傳對應的圖片路徑
export const transFormCreditCardTypeToImgUrl = (cardType) => {
  const checkCardType = cardType.toLowerCase();
  switch (checkCardType) {
    case 'master':
      return '/_ui/responsive/theme-trplus/images/creditcard/MASTERCARD_e.png';
    case 'visa':
      return '/_ui/responsive/theme-trplus/images/creditcard/VISA_e.png';
    case 'jcb':
      return '/_ui/responsive/theme-trplus/images/creditcard/JCB_e.png';
    default:
      return '';
  }
};

// 在cookie增加debugMode，如果已經有debugMode就不再寫入cookie
export const setDebugModeCookie = () => {
  const prevDebugMode = Cookies.get('debugMode');
  if (prevDebugMode === undefined || prevDebugMode === null) {
    document.cookie = 'debugMode=0;path=/';
  }
};

export const checkIfDebugModePrintLog = (err) => {
  const debugMode = Cookies.get('debugMode');
  if (debugMode === '1') {

  }
};

// 全形數字轉半形數字 - 輸入地址資訊需使用
export const convertFullToHalfNumber = (street) => {
  let returnString = '';
  for (let i = 0; i < street.length; i++) {
    if (street.charCodeAt(i) > 65248 && street.charCodeAt(i) < 65375) {
      returnString += String.fromCharCode(street.charCodeAt(i) - 65248);
    } else {
      returnString += String.fromCharCode(street.charCodeAt(i));
    }
  }
  returnString = returnString.replace(/\s+/g, '');
  // returnString.trimAll();
  return returnString;
};

// trim 相關的部分都沒有搬移，理論上原生的 string prototype 會有 trim 的 function
// 真的不行的話就會使用 lodash 裏面的 trim

// const userOs = navigator.userAgent.toLowerCase();
// //判斷是否是IOS
// const isIos = (userOs.indexOf('iphone') != -1) || (userOs.indexOf('ipad') != -1);

export const updateIsShowToTopIcon = () => {
  const toTopIcon = document.querySelector('.mobile.gototop--wrap');
  const topTopClassName = toTopIcon.className;
  const isShowIcon = topTopClassName.indexOf('d-none') === -1;
  if (isShowIcon) {
    toTopIcon.className += ' d-none';
  } else {
    toTopIcon.className = toTopIcon.className.replace(' d-none', '');
  }
};

// 判空處理
export const isEmpty = (obj) => {
  // 校驗null和undefined
  if (!obj && obj !== 0 && obj !== '') {
    return true;
  }
  // 校驗數組
  if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
    return true;
  }
  // 校驗對象
  if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};
